export function canAccessPresupuestos(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true || user.role === 'admin') return true;

  const slug = String(user.currentPlan?.slug || '').toLowerCase();
  if (['empresarial', 'enterprise', 'business'].includes(slug)) return true;

  const features = user.unlockedFeatures || user.currentPlan?.features || {};
  return !!(features.presupuestos);
}

export function canAccessEmpresarialFeatures(user) {
  return canAccessPresupuestos(user);
}
